export default function selectUserChoiceValues(state) {
  return state?.app?.userChoiceValues || {};
}
